const INDEX_ITEMS = [
  { icon: 'ri-movie-line', label: '电影', count: '8500+', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-tv-line', label: '电视剧', count: '12000+', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-live-line', label: '综艺', count: '3500+', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-ghost-line', label: '动漫', count: '5000+', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-slideshow-line', label: '纪录片', count: '2000+', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-fire-line', label: '热播榜', count: 'TOP100', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-star-line', label: '高分推荐', count: '8.5+', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-calendar-line', label: '最新上映', count: '每日更新', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-heart-line', label: '我的收藏', count: '专属片单', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          全站分类导航
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按类别浏览，快速找到您想看的内容
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {INDEX_ITEMS.slice(0, 5).map((item, i) => (
            <a
              key={i}
              href="#"
              className="bg-background-50 rounded-2xl p-5 border border-background-200/60 hover:border-primary-200 transition-colors text-center group cursor-pointer"
            >
              <div className={`w-12 h-12 mx-auto rounded-xl flex items-center justify-center mb-3 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                {item.label}
              </h3>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
          {INDEX_ITEMS.slice(5).map((item, i) => (
            <a
              key={i + 5}
              href="#"
              className="bg-background-50 rounded-2xl p-5 border border-background-200/60 hover:border-primary-200 transition-colors text-center group cursor-pointer"
            >
              <div className={`w-12 h-12 mx-auto rounded-xl flex items-center justify-center mb-3 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                {item.label}
              </h3>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}